export default "__VITE_ASSET__DIZS2v5t__"